var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-header__wrapper"},[_c('div',{staticClass:"step-header__title"},[_vm._t("title")],2),_c('div',{staticClass:"step-header__close",on:{"click":function($event){return _vm.$emit('close')}}},[_c('gl-icon',{attrs:{"gray":"","height":24,"name":"I-S-Close","width":24}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }